module.exports = __webpack_public_path__ + "static/meet-our-weirdos-OG-46bf553b05b948ac58dab5298467f2bc.png";